<template>
  <div class="section">
    <!-- The image -->
    <v-img
      contain
      height="273"
      class="section__image"
      src="/img/png/women.png"
      v-prlx="{ reverse: true }"
      v-vue-aos.once="{ animationClass:'fadeInUp slow animated' }"
    />

    <!-- The container -->
    <div
      class="section__container"
      v-vue-aos.once="{ animationClass:'fadeIn slower animated' }"
    >
      <!-- The title -->
      <div class="section__title font-weight-bold primary--text text-center">
        What If You Could FInd Influencers with Business Merit
      </div>

      <!-- The subtitle -->
      <div class="section__subtitle bluegray--text text-center mx-auto mt-2">
        Using a Multitude of Filters for them & Their  Audiences -  Age, Sex, Location, Authenticity, Engagement, Relevance and aspects that can do truly incisive and Business Impacting
      </div>

      <!-- The auto-scroll section -->
      <v-sheet
        class="mx-auto pb-8 mt-6 transparent"
        max-width="1200"
      >
        <v-slide-group
          show-arrows
        >
          <v-slide-item
            v-for="(item, index) in items"
            :key="index"
          >
            <v-btn
              class="mx-2 transparent bluegray--text font-weight-bold"
              depressed
              rounded
            >
              <v-img
                contain
                class="mr-3"
                max-height="20"
                max-width="18"
                :src="item.icon"
              />

              {{ item.text }}
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
    </div>
  </div>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: "Categories",

  // Define local data variables
  data: () => ({
    items: [
      {
        icon: '/img/icons/categories/automotive.svg',
        text: 'Automotive'
      },
      {
        icon: '/img/icons/categories/beauty.svg',
        text: 'Beauty'
      },
      {
        icon: '/img/icons/categories/business.svg',
        text: 'Business'
      },
      {
        icon: '/img/icons/categories/entertainment.svg',
        text: 'Entertainment'
      },
      {
        icon: '/img/icons/categories/fashion.svg',
        text: 'Fashion'
      },
      {
        icon: '/img/icons/categories/fitness.svg',
        text: 'Fitness'
      },
      {
        icon: '/img/icons/categories/food.svg',
        text: 'Food'
      },
      {
        icon: '/img/icons/categories/gadget.svg',
        text: 'Gadget'
      },
      {
        icon: '/img/icons/categories/game.svg',
        text: 'Game'
      },
      {
        icon: '/img/icons/categories/health.svg',
        text: 'Health'
      },
      {
        icon: '/img/icons/categories/lifestyle.svg',
        text: 'Lifestyle'
      },
      {
        icon: '/img/icons/categories/sports.svg',
        text: 'Sports'
      },
      {
        icon: '/img/icons/categories/travel.svg',
        text: 'Travel'
      }
    ]
  })
}
</script>

<style lang="stylus" scoped>
.section
  margin-top -152px

  &__image
    position relative
    bottom -112px

  &__title
    font-size 1.5em

  &__subtitle
    font-size 1em
    max-width 50em

  &__container
    padding-top 5em
    background rgba(176, 190, 197, 0.2)
</style>
